<template>
    <span class="dk-media-swipe-viewer" @click="onClick">
        <slot></slot>
    </span>
</template>

<script>
import Vue from 'vue';
import { EventBus } from '@v4/common/utils/event-bus';

/**
 * Wrapper of DkMediaSwipe component.
 * Asynchronous gallery visualization.
 *
 * @version 4.0.0
 * @example ./../examples/DkMediaSwipeViewer.md
 */
export default {
    name: 'DkMediaSwipeViewer',
    data() {
        return {
            component: null,
        };
    },
    computed: {
        refDkMediaSwipe() {
            return (this.component && this.component.$refs && this.component.$refs.dkMediaSwipe) || {};
        },
    },
    mounted() {
        EventBus.$on('Hero-image:open-gallery', this.handleClickOnHeroImage);
    },
    beforeDestroy() {
        EventBus.$off('Hero-image:open-gallery', this.handleClickOnHeroImage);
    },
    methods: {
        onClick(isClickOnHeroImage = false) {
            this.defineAsyncComponent().then(() => {
                if (typeof this.refDkMediaSwipe.show !== 'function') {
                    return;
                }

                this.refDkMediaSwipe.show();

                /**
                 * Fired when gallery has shown
                 *
                 * @event show
                 * @type {Object}
                 * @property {object} photoSwipe - photoSwipe instance
                 */
                const dataForGalleryOpening = {
                    photoSwipe: this.refDkMediaSwipe.photoSwipe || {},
                    isClickOnHeroImage,
                };
                this.$emit('show', dataForGalleryOpening);
            });
        },
        defineAsyncComponent() {
            return new Promise((resolve, reject) => {
                if (this.component) {
                    return resolve();
                }

                import(
                    /* webpackChunkName: "DkMediaSwipe-vue" */ '@v4/common/components/organisms/DkMediaSwipe/DkMediaSwipe.vue'
                )
                    .then(({ default: DkMediaSwipe }) => {
                        const div = document.createElement('div');
                        this.$root.$el.appendChild(div);

                        this.component = new Vue({
                            parent: this.$root,
                            render: (h) =>
                                h(DkMediaSwipe, {
                                    props: this.$attrs,
                                    ref: 'dkMediaSwipe',
                                    on: {
                                        ...this.$listeners,
                                        'hook:mounted': resolve,
                                    },
                                }),
                        }).$mount(div);
                    })
                    .catch(reject);
            });
        },
        handleClickOnHeroImage() {
            this.onClick(true);
        },
    },
};
</script>
